import { texts } from "../texts"

export const footerLinks = () => {
    return [{ text: texts.prices, url: "/prices" }, { text: texts.contactUs, url: "/contactUs" }]
};
